import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@asambleas-env/environment';

@Injectable()
export class CitiesService {

  constructor(private http: HttpClient) { }

  getAllCities() {
    return this.http.get(environment.apiEndPoint + '/ciudades');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/cities/cities.service.ts